<template>
  <div class="alarmDict-container">
    <el-form size="medium" inline :model="queryForm" @submit.native.prevent>
      <el-form-item class="query-form alarm-type" label="告警类型:">
        <el-checkbox-group v-model="queryForm.parentType" @change="typeChange">
          <el-checkbox
            v-for="item in typeList"
            :key="item.code"
            :label="item.code"
            >{{ item.value }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item class="query-form r-20" label="告警名称:">
        <el-select
          v-model="queryForm.typeId"
          placeholder="请选择告警名称"
          no-data-text="请先选择告警类型"
          clearable
        >
          <el-option
            v-for="(item, index) in alarmNameList"
            :label="handleViolation(item)"
            :value="item.type"
            :key="`${item.type} + ${index}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="r-20">
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">取消</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      height="560px"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
    >
      <el-table-column width="40"></el-table-column>
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column
        prop="type"
        label="告警类型"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="告警名称"
        width="160"
      ></el-table-column>
      <el-table-column
        prop="illustrate"
        label="告警说明"
        min-width="180"
      ></el-table-column>
      <el-table-column prop="secure" label="解除方式">
        <template slot-scope="{ row }">
          <span v-if="row.secure == 1">手动解除</span>
          <span v-else-if="row.secure == 2">自动解除</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="phones" label="手机号"></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="{ row }">
          <el-button size="mini" type="text" @click.stop="editorPhone(row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 修改手机号 -->
    <el-dialog
      title="修改手机号"
      :visible.sync="dialogPhone"
      class="mini-dialog phoneDialog"
    >
      <el-form :model="phoneForm" inline>
        <div style="color:#ff0000;margin:0 0 10px 10px;">
          * 请输入手机号，多个手机号使用英文逗号","分隔开 *
        </div>
        <el-form-item prop="phones" label="手机号">
          <el-input
            v-model.trim="phoneForm.phones"
            placeholder='请输入手机号，多个手机号使用英文逗号","分隔开'
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPhone = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AlarmDict",
  data() {
    return {
      queryForm: {
        parentType: [],
        typeId: null,
      },
      typeList: [],
      alarmNameList: [],
      tableData: [],
      total: 0,
      limit: 10,
      currentPage: 1,
      dialogPhone: false,
      phoneForm: {
        phones: "",
        id: null,
      },
    };
  },
  watch: {
    "queryForm.parentType"(val) {
      let _this = this;
      if (val) {
        this.$nextTick(() => {
          _this.getAlarmNameList();
        });
      }
    },
  },
  mounted() {
    this.query();
    this.getAlarmType();
  },
  methods: {
    query() {
      this.getAlarmList();
    },
    reset() {
      this.queryForm.parentType = [];
      this.queryForm.typeId = null;
      this.getAlarmList();
    },
    editorPhone(rowData) {
      // 清空数据
      this.phoneForm.phones = "";
      // 赋值数据
      this.phoneForm.phones = rowData.phones;
      this.phoneForm.id = rowData.id;
      this.dialogPhone = true;
    },
    // 提交保存修改手机号
    async saveOrUpdate() {
      // 修改数据
      let obj = {};
      obj.ID = this.phoneForm.id;
      obj.phones = this.phoneForm.phones;
      let { data: res } = await this.$axios.get(
        "/api/warn/remind/warnRemindTypeUpdate",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.$message.success(res.msg);
        // 关闭弹框
        this.dialogPhone = false;
        // 刷新表格数据
        this.getAlarmList();
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 告警类型
    async getAlarmType() {
      let { data: res } = await this.$axios.get(
        "/api/sys/dict/" + "warnRemind"
      );
      if (res.code == 1) {
        this.typeList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    //获取告警名称列表
    async getAlarmNameList() {
      let obj = {
        parentType: this.queryForm.parentType.toString(),
      };
      let { data: res } = await this.$axios.get("/api/warn/remind/type", {
        params: obj,
      });
      if (res.code == 1) {
        this.alarmNameList = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 处理后台返回数据项‘违规加油’的显示
    handleViolation(item) {
      if (item.type == 1202) {
        return "未熄火加油/未在加油站加油";
      } else {
        return item.name;
      }
    },
    async getAlarmList() {
      let obj = {};
      obj.parentType = this.queryForm.parentType.toString();
      obj.type = this.queryForm.typeId;
      obj.page = this.currentPage;
      obj.limit = this.limit;
      let { data: res } = await this.$axios.get(
        "/api/warn/remind/listWarnRemindType",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 更新选中的复选框数据
    typeChange(val) {
      this.queryForm.parentType = val;
      this.queryForm.typeId = null;
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getAlarmList();
    },
  },
};
</script>

<style lang="scss" scoped>
.alarmDict-container {
  height: calc(100% - 60px);
  margin: 20px;
  padding: 20px;
  padding-bottom: 0;
  background: #fff;
  /deep/ .el-form--inline .el-form-item__content {
    width: 260px;
  }
  .alarm-type {
    display: block !important;
    /deep/ .el-form-item__content {
      width: auto;
    }
    .el-checkbox-group {
      height: 22px;
    }
    .el-form-item__label,
    .el-form-item__content {
      line-height: 22px !important;
      float: left;
    }
  }
}
</style>
